module.exports = __webpack_public_path__ + "assets/images/30e854e6a8cb87c104b447a35f40f6b9.png";